import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_measures_in_place_relate'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_measures_in_place_relate',
  name: 'Does the facility have any of the following measures in place related to a Fire Brigade/Emergency Response Team?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'MEMBERS_OF_THE_FIRE_BRIGADE_EMERGENCY_RESPONSE_TEAM_UNDERGO_BOT',
      text: 'Members of the Fire Brigade/Emergency Response Team undergo both initial and refresher trainings on their responsibilities',
      externalIds: [
        {
          id: 'hs-24--1-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe when and how often members of the Fire Brigade/Emergency Response Team undergo both initial and refresher trainings on their responsibilities:',
        externalIds: [
          {
            id: 'hs-24--1-1f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'MEMBERS_OF_THE_FIRE_BRIGADE_EMERGENCY_RESPONSE_TEAM_HAVE_THE_AP',
      text: 'Members of the Fire Brigade/Emergency Response Team have the appropriate equipment to fight fires (including the correct PPE, e.g., breathing apparatus)',
      externalIds: [
        {
          id: 'hs-24--1-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-24--1-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'MEMBERS_OF_THE_FIRE_BRIGADE_EMERGENCY_RESPONSE_TEAM_UNDERGO_BOT',
                'MEMBERS_OF_THE_FIRE_BRIGADE_EMERGENCY_RESPONSE_TEAM_HAVE_THE_AP',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-eme-7',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 15090,
  sectionId: '2.2.9.4',
  impactArea: 'Emergency Preparedness',
  impactAreaId: 'EMERGENCY_PREPAREDNESS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
